/* eslint-disable camelcase */
import { DeviceType, DeviceTypes } from 'AppShell/appshell_types/appshellMetaTypes';
import { ClubAdjustTrackers, ClubAdjustTracker, ClubAppLinkFunc } from 'AppShell/appshell_types/clubHelpers';
import buildUrl from 'build-url';

/**
 * Make sure logic and configs stay in sync with Club Alice
 * alice/alice/protected/components/service/SmartBannerService.php
 */

const URL = 'https://82ef.adj.st';

const trackers: Record<ClubAdjustTracker, Partial<Record<DeviceType, string>>> = {
    [ClubAdjustTrackers.SMARTBANNER]: {
        [DeviceTypes.ANDROID]: 'fc5qss6_zq7e1er',
        [DeviceTypes.IOS]: 'fc5qss6_zq7e1er',
    },
    [ClubAdjustTrackers.DELAYSTART]: {
        [DeviceTypes.ANDROID]: 'y2bqgri_enj9oim',
        [DeviceTypes.IOS]: 'y2bqgri_enj9oim',
    },
    [ClubAdjustTrackers.FOOTER]: {
        [DeviceTypes.ANDROID]: '10hp9xyv',
        [DeviceTypes.IOS]: '10yfhswo',
    },
};

const getClubAppDeeplink = (fixedDeeplink?: string, loginHash?: string) => {
    // eslint-disable-next-line react-hooks-ssr/react-hooks-global-ssr
    let deeplink = fixedDeeplink ?? window.location.href.split('#')[0];

    if (loginHash) {
        deeplink += `${deeplink.includes('?') ? '&' : '?'}loginHash=${loginHash}`;
    }

    return deeplink;
};

export const getClubAppLink: ClubAppLinkFunc = (
    device,
    fallBackFor,
    country,
    type,
    appData,
    fixedDeeplink
    // eslint-disable-next-line max-params
) => {
    let fallbackURL = `${appData.host}/c/app/`;

    if (fallBackFor === DeviceTypes.ANDROID) {
        fallbackURL = `https://play.google.com/store/apps/details?id=de.westwing.android&hl=${country ?? 'de'}`;
    } else if (fallBackFor === DeviceTypes.IOS) {
        fallbackURL = `https://apps.apple.com/${country ?? 'de'}/app/westwing-möbel-deko/id637660112`;
    }

    if ([DeviceTypes.ANDROID, DeviceTypes.IOS].includes(device as DeviceTypes)) {
        const tracker = trackers[type][device] || '';
        const deepLinkURL = getClubAppDeeplink(fixedDeeplink, appData.loginHash);

        return buildUrl(URL, {
            queryParams: {
                adjust_t: tracker,
                adjust_deeplink: deepLinkURL,
                adjust_fallback: fallbackURL,
            },
        });
    }

    return fallbackURL;
};
